import React from 'react';
import PropTypes from 'prop-types';

const StatusIndicator = ({ 
  status = 'idle', // 'idle' | 'loading' | 'success' | 'error' | 'warning'
  icon,
  message, 
  className = '',
  ...rest 
}) => {
  const statusConfig = {
    idle: {
      bgClass: 'bg-succession-bg-tertiary',
      borderClass: 'border-succession-border',
      dotClass: 'bg-succession-text-muted',
      textClass: 'text-succession-text-secondary',
      defaultIcon: '○',
    },
    loading: {
      bgClass: 'bg-blue-50',
      borderClass: 'border-blue-200',
      dotClass: 'bg-blue-400 animate-pulse',
      textClass: 'text-blue-700',
      defaultIcon: '⟳',
    },
    success: {
      bgClass: 'bg-green-50',
      borderClass: 'border-green-200',
      dotClass: 'bg-green-400',
      textClass: 'text-green-700',
      defaultIcon: '✓',
    },
    error: {
      bgClass: 'bg-red-50',
      borderClass: 'border-red-200',
      dotClass: 'bg-red-400',
      textClass: 'text-red-700',
      defaultIcon: '×',
    },
    warning: {
      bgClass: 'bg-amber-50',
      borderClass: 'border-amber-200',
      dotClass: 'bg-amber-400',
      textClass: 'text-amber-700',
      defaultIcon: '!',
    },
  };

  const config = statusConfig[status] || statusConfig.idle;
  const displayIcon = icon !== undefined ? icon : config.defaultIcon;

  return (
    <div 
      className={`p-4 rounded-lg border-2 transition-all duration-300 ${config.bgClass} ${config.borderClass} ${className}`}
      {...rest}
    >
      <div className="flex items-center space-x-3">
        <div className={`w-3 h-3 rounded-full ${config.dotClass}`} />
        <p className={`text-sm font-medium ${config.textClass}`}>
          {displayIcon && <span className="mr-1">{displayIcon}</span>}
          {message}
        </p>
      </div>
    </div>
  );
};

StatusIndicator.propTypes = {
  status: PropTypes.oneOf(['idle', 'loading', 'success', 'error', 'warning']),
  icon: PropTypes.node,
  message: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default StatusIndicator;

